import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { toggleTechView } from '../../../store/user/user.actions';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-switch-profile',
  standalone: true,
  imports: [CommonModule, MatIcon, MatIconModule],
  templateUrl: './switch-profile.component.html',
  styleUrl: './switch-profile.component.css'
})
export class SwitchProfileComponent {
  isTechView$ = this.store.select('user').pipe(map(userState => userState.isTechView));
  constructor(private store: Store<{ user: { isTechView: boolean } }>, private router: Router) {}

  switchToTech() {
    this.store.dispatch(toggleTechView());
    this.router.navigate(['/technician/home']);
  }

  switchToAdmin() {
    this.store.dispatch(toggleTechView());
    this.router.navigate(['/admin/dashboard']);
  }
}